import AccountInfoPanel from './AccountInfoPanel';

export default AccountInfoPanel;
